export default __webpack_public_path__ + "static/media/ruby-bow.55ba2eed.gif";